"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuery = void 0;
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const query_string_1 = __importDefault(require("query-string"));
const useClient_1 = require("../../hooks/useClient/useClient");
const useQuery = (queryKey, query, options) => {
    const { axios: client } = (0, useClient_1.useClient)();
    const { endpoint, responseType } = query(options?.args);
    const queryFn = (0, react_1.useCallback)(() => {
        const queryParams = options?.args ? `?${query_string_1.default.stringify(options?.args, { arrayFormat: 'comma' })}` : '';
        return client.get(`${endpoint}${queryParams}`, { responseType });
    }, [client, endpoint, options]);
    return (0, react_query_1.useQuery)(queryKey, queryFn, options);
};
exports.useQuery = useQuery;
